// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"styles_text-gradient__1I1FA","label":"styles_label__1kPO0","btn":"styles_btn__3hg1p","active":"styles_active__yhp84"};